import { Inject, Injectable } from '@angular/core';
import { ICmxClientConfig } from '../typings/client-config';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(@Inject('ClientConfig') private config: ICmxClientConfig) {}

  getConfig(): ICmxClientConfig {
    return { ...this.config };
  }
}
